import React, { Component } from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux'
import { steamService } from '../../../services'
import { steamActions } from '../../../redux/actions'
import FormattedMessage from '../../../components/FormattedMessage/FormattedMessage'
import Loader from '../../../components/Loader/Loader'

const steamTicket = 'steam_v1'
const steamAuthTimeout = 120000

class ConnectToSteam extends Component {
  constructor(props) {
    super(props)
    this.storageInterval = null
    this.storageTimeout = null
    this.state = {
      loading: false,
    }
  }

  componentDidMount() {
    const { checkAuthenticated, saveAuthUser, user } = this.props

    checkAuthenticated(user)
      .then(() => {
        const localStorage = window.localStorage.getItem(steamTicket)
        if (localStorage) saveAuthUser(localStorage)
      })
      .catch(() => steamService.removeUserTicket())
      .finally(() => this.setState({ loading: false }))
  }

  componentWillUnmount() {
    this.clearStorageCheck()
  }

  openWindow = () => {
    const { authenticated, saveAuthUser } = this.props
    this.setState({ loading: true })
    const steamWindow = window.open(
      steamService.buildLoginAuthUrl(),
      'Steam Oauth',
      'width=700,height=600'
    )

    if (!steamWindow) {
      this.setState({ loading: false })
      return
    }

    this.checkStorage(steamWindow)
      .then(localStorage => {
        this.setState({ loading: false }, () => !authenticated && saveAuthUser(localStorage))
      })
      .catch(() => this.setState({ loading: false }))
  }

  clearStorageCheck = () => {
    if (this.storageInterval) {
      clearInterval(this.storageInterval)
      this.storageInterval = null
    }
    if (this.storageTimeout) {
      clearTimeout(this.storageTimeout)
      this.storageTimeout = null
    }
  }

  checkStorage = steamWindow =>
    new Promise((resolve, reject) => {
      this.clearStorageCheck()

      this.storageTimeout = setTimeout(() => {
        this.clearStorageCheck()
        reject(new Error('Steam authentication timed out'))
      }, steamAuthTimeout)

      this.storageInterval = setInterval(() => {
        const localStorage = window.localStorage.getItem(steamTicket)
        if (localStorage) {
          this.clearStorageCheck()
          resolve(localStorage)
        } else if (steamWindow.closed) {
          this.clearStorageCheck()
          reject(new Error('Steam authentication window closed'))
        }
      }, 1000)
    })

  logout = () => {
    const { removeAuthUser } = this.props
    removeAuthUser()
  }

  button = authenticated => (
    <Button
      name="connectSteamSubmitBtn"
      type="submit"
      outline
      color="dark"
      size="sm"
      block
      onClick={authenticated ? this.logout : this.openWindow}
      aria-label={authenticated ? 'Disconnect from Steam' : 'Connect to Steam'}
    >
      <FormattedMessage id={authenticated ? 'steam.button.logout' : 'steam.button.connect'} />
    </Button>
  )

  render() {
    const { authenticated } = this.props
    const { loading } = this.state

    return (
      <div>
        <div className="row justify-content-center py-4">
          <div className="col-md-8 col-xl-6">
            {loading ? <Loader button /> : this.button(authenticated)}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  authenticated: state.steamReducer.authenticated,
  user: state.userReducers,
})

const mapDispatchToProps = dispatch => ({
  checkAuthenticated: (...args) => dispatch(steamActions.checkAuthenticated(...args)),
  removeAuthUser: () => dispatch(steamActions.removeAuthUser()),
  saveAuthUser: (...args) => dispatch(steamActions.saveAuthUser(...args)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ConnectToSteam)
